import { ChevronDown, MapPin, Menu, Search, ShoppingBag, UserRound, X } from "lucide-react";
import { FormEvent, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useBranch } from "../../contexts/BranchContext";
import { useCart } from "../../contexts/CartContext";
import { useStorefront } from "../../contexts/StorefrontContext";
import { getStoreStatus } from "../../lib/storeStatus";

export function StoreHeader() {
  const { store, categories } = useStorefront();
  const { branch, openSelector } = useBranch();
  const { itemCount } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  if (!store) return null;
  const status = getStoreStatus(branch?.businessHours ?? store.businessHours);

  const submitSearch = (event: FormEvent) => {
    event.preventDefault();
    if (query.trim()) navigate(`/search?q=${encodeURIComponent(query.trim())}`);
  };

  return (
    <>
      <div className="announcement-bar">
        <span className={status.isOpen ? "status-dot open" : "status-dot"} />
        {status.label}
        <span className="announcement-divider" />
        {store.freeDeliveryThreshold ? `Free delivery over Rs. ${store.freeDeliveryThreshold.toLocaleString()}` : store.tagline}
      </div>
      <header className="store-header">
        <div className="header-main page-width">
          <button className="icon-button mobile-only" onClick={() => setMenuOpen(true)} aria-label="Open navigation"><Menu /></button>
          <Link className="store-brand" to="/">
            {store.logo ? <img src={store.logo} alt="" /> : <span>{store.storeName.slice(0, 1)}</span>}
            <div><strong>{store.storeName}</strong><small>{store.tagline}</small></div>
          </Link>
          <form className="header-search" onSubmit={submitSearch} role="search">
            <Search aria-hidden="true" />
            <input
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              placeholder="Search products, categories or brands"
              aria-label="Search store"
            />
            <button type="submit">Search</button>
          </form>
          <button className="branch-button" onClick={openSelector}>
            <MapPin />
            <span><small>Shopping from</small><strong>{branch?.name ?? "Choose branch"}</strong></span>
            <ChevronDown />
          </button>
          <button className="icon-button desktop-only" aria-label="Customer account, coming soon"><UserRound /></button>
          <Link className="cart-button" to="/cart" aria-label={`Cart with ${itemCount} items`}>
            <ShoppingBag />
            <span>{itemCount}</span>
          </Link>
        </div>
        <nav className="category-nav page-width" aria-label="Shop categories">
          <NavLink to="/products">All products</NavLink>
          {categories.slice(0, 8).map((category) => (
            <NavLink key={category.id} to={`/category/${category.slug}`}>{category.name}</NavLink>
          ))}
          <NavLink to="/track-order">Track order</NavLink>
        </nav>
      </header>
      {menuOpen && (
        <div className="mobile-menu-backdrop" onClick={() => setMenuOpen(false)}>
          <nav className="mobile-menu" onClick={(event) => event.stopPropagation()} aria-label="Mobile navigation">
            <div className="mobile-menu-title"><strong>{store.storeName}</strong><button onClick={() => setMenuOpen(false)} aria-label="Close navigation"><X /></button></div>
            <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
            <Link to="/products" onClick={() => setMenuOpen(false)}>All products</Link>
            {categories.map((category) => <Link key={category.id} to={`/category/${category.slug}`} onClick={() => setMenuOpen(false)}>{category.name}</Link>)}
            <Link to="/track-order" onClick={() => setMenuOpen(false)}>Track order</Link>
          </nav>
        </div>
      )}
    </>
  );
}
